import { useCallback, useState } from 'react';
import { API_CORE } from '../../../../../_CORE/API/ApiCORE';
import { QUOTE_PUBLIC_CONSTANTS } from '../_MODULES/QuoteApi';

export const useQuoteSubmission = () => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null);

    const submitQuote = useCallback(async (payload) => {
        setIsSubmitting(true);
        setError(null);

        try {
            const endpoint = API_CORE.ENDPOINTS[QUOTE_PUBLIC_CONSTANTS.CREATE];
            if (!endpoint) throw new Error('El cotizador no está disponible en este momento.');

            const response = await API_CORE.SERVICES.POST_RESOURCE(endpoint, payload);
            const status = response?.status ?? response?.code_status ?? 500;
            if (status >= 400 || response?.success === false) {
                throw new Error(response?.message || 'No se pudo enviar la solicitud.');
            }

            return response?.data ?? response;
        } catch (currentError) {
            const normalized = currentError instanceof Error
                ? currentError
                : new Error('No se pudo enviar la solicitud.');
            setError(normalized);
            throw normalized;
        } finally {
            setIsSubmitting(false);
        }
    }, []);

    const clearError = useCallback(() => setError(null), []);

    return { submitQuote, isSubmitting, error, clearError };
};
